import React, { FC } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

import "./index.scss";

interface StationViewRawDataDelayLoaderProps {
  isLoading: boolean;
  onComplete: () => void;
}

const StationViewRawDataDelayLoader: FC<StationViewRawDataDelayLoaderProps> = ({ isLoading, onComplete }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="global-loading-wrapper">
      <div className="global-loading">
        <CountdownCircleTimer
          isPlaying
          size={110}
          strokeWidth={6}
          duration={2.5 * 60}
          colors={["#3491e3", "#F7B801", "#A30000", "#A30000"]}
          colorsTime={[7, 5, 2, 0]}
          onComplete={onComplete}
        >
          {({ remainingTime }) => (
            <div className="loading-timer-content">
              <div className="timer">{remainingTime}</div>
              <div>Seconds</div>
            </div>
          )}
        </CountdownCircleTimer>
      </div>
    </div>
  );
};

export default StationViewRawDataDelayLoader;
